import styled from 'styled-components'
import CalendarOriginal from 'components/Calendar'
import { colors } from 'themes'
import LabeledCheckbox from 'components/LabeledCheckbox'

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	width:100%;
`

export const Calendar = styled(CalendarOriginal)`
	margin-top: 15px;
	align-self: center;
`

export const Divider = styled.div`
	margin: 56px 0 22px;
	border: 1px solid #CBE1EA;
`

export const PopUpContainer = styled.div`
	position: relative;
	background: ${colors.addCard.background};
	border-radius: 14px;
	height: 150px;
	text-align: center;
	display: flex;
	justify-content: space-between;
	flex-direction: column;
	align-items: stretch;
	padding: 20px;
	
	color: #276273;
`

export const Checkbox = styled(LabeledCheckbox)`
	margin-top: 20px;
`